import { useTranslation } from 'react-i18next';

import { useGlobalUI } from '@/components/GlobalUIProvider';
import { useSendMDMEnrollInstructionsMutation } from '@/redux/slices/employeeApiSlice';
import { useAppSelector } from '@/redux/store';
import { Employee } from '@/types/employees';
import MDMInviteModal from '@/components/Organization/MDMInviteModal/MDMInviteModal';
import { Asset } from '@/types/assets';

type MDMInviteModalWrapperProps = {
  employeesWithDevices: { employee: Employee; devices: Asset[] }[];
  inviteVisible: boolean;
  handleModalClose: () => void;
};

const MDMInviteModalWrapper = ({
  employeesWithDevices,
  inviteVisible,
  handleModalClose,
}: MDMInviteModalWrapperProps) => {
  const { t } = useTranslation('billing');
  const { showSuccessToast, showErrorToast } = useGlobalUI();
  const organizationId =
    useAppSelector(state => state.loggedUser?.organizationId) || '';
  const [sendMDMEnrollInstructions, { isLoading }] =
    useSendMDMEnrollInstructionsMutation();

  const handleSubmit = async () => {
    const selectedEmployees = employeesWithDevices
      ?.map(entry => entry.employee)
      .filter(employee => employee?.email?.length);
    try {
      await sendMDMEnrollInstructions({
        employeeIds: [
          ...new Set(selectedEmployees?.map(employee => employee.id) || []),
        ],
        organizationId,
      }).unwrap();

      const peopleLabel = t(
        'organization.mdmInviteModalWrapper.toasts.sendSuccessPeople',
        { count: selectedEmployees?.length || 0 }
      );
      showSuccessToast({
        id: 'mdm-enroll-instructions-sent-success-toast',
        stack: true,
        message: t('organization.mdmInviteModalWrapper.toasts.sendSuccess', {
          count: selectedEmployees?.length || 0,
          peopleLabel,
        }),
      });
      handleModalClose();
    } catch (error) {
      console.error(`Unable to send desktop app invite emails for `, error);
      showErrorToast({
        id: 'mdm-enroll-instructions-sent-error-toast',
        stack: true,
        title: t('organization.mdmInviteModalWrapper.toasts.sendErrorTitle'),
        message: t('organization.mdmInviteModalWrapper.toasts.sendError'),
      });
    }
  };
  return (
    <>
      <MDMInviteModal
        hide={handleModalClose}
        employeesWithDevices={employeesWithDevices}
        isLoading={isLoading}
        visible={inviteVisible}
        handleCancel={handleModalClose}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default MDMInviteModalWrapper;
